import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';
import { FormService } from '../../services/form.service';
import { VedraxApiService } from '../../services/vedrax-api.service';
import { NVP } from '../../shared';
import { VedraxAutocompleteDataSource } from './vedrax-autocomplete.datasource';

@Component({
  selector: 'vedrax-autocomplete',
  templateUrl: './vedrax-autocomplete.component.html',
  styleUrls: ['./vedrax-autocomplete.component.scss']
})
export class VedraxAutocompleteComponent implements OnInit, OnDestroy {

  /**
   * Subscription
   */
  private subscription: Subscription = new Subscription();

  /**
   * The form
   */
  @Input() form: FormGroup = new FormGroup({});

  /**
   * The search form
   */
  searchForm: FormGroup = new FormGroup({});

  /**
  * The list of filters
  */
  filters: DescriptorFormControl[] = [];

  /**
   * The control descriptor
   */
  @Input() descriptor: DescriptorFormControl = new DescriptorFormControl();

  /**
   * The selected value
   */
  selected: NVP | undefined;

  /**
   * Used for toggle the search filters
   */
  search: boolean = false;

  /**
   * Is the request submitted
   */
  submitted: boolean = false;

  /**
   * The datasource
   */
  datasource: VedraxAutocompleteDataSource;

  /**
  * Use for calculating height of frame
  */
  visibleOptions = 4;

  constructor(
    private formService: FormService,
    private apiService: VedraxApiService) {
    this.datasource = new VedraxAutocompleteDataSource(this.apiService);
  }

  ngOnInit(): void {

    const controlSearchDescriptor = this.descriptor.controlSearch;

    if (controlSearchDescriptor) {
      this.filters = controlSearchDescriptor.filters;
      this.datasource.setEndpoint(controlSearchDescriptor.endpoint);
      this.datasource.setDefaultParams(controlSearchDescriptor.defaultParams);
    }
    this.selected = this.descriptor.controlValue || { key: 0, value: '' };

    //add search form to datasource class for subscribing for change
    this.searchForm = this.formService.createFormGroup(this.filters);
    this.datasource.initSearch(this.searchForm);

    this.subscription.add(this.datasource.submitted$.subscribe(status => this.submitted = status));

  }

  /**
   * Unsubscription
   */
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Toggle search
   */
  openSearch(): void {
    this.search = true;
  }

  /**
   * Close search
   */
  closeSearch(): void {
    this.search = false;
  }

  /**
   * Method for selecting an option
   * @param option 
   */
  select(option: NVP): void {
    if (option) {
      this.search = false;
      this.selected = option;
      this.formControl.setValue(option.key);
    }
  }

  /**
   * Clear search
   */
  clearSearch(): void {
    this.selected = { key: 0, value: '' };
    this.formControl.reset();
  }

  /**
   * Accessor for getting the specified form control
   */
  get formControl(): FormControl {
    return this.form.get(this.descriptor.controlName) as FormControl;
  }

}
